import type { FC } from 'react'
import { Tooltip, useTheme } from '@mui/material'
import ComputerOutlined from '@mui/icons-material/ComputerOutlined'
import { standardTooltipProps } from '@/common/components'
import { HostStatus } from '@/infra/sse/status/types'
import { getHostStatusColor, HOST_STATUS_LABELS } from '@/features/status'

interface HostStatusIconProps {
  readonly status?: HostStatus | null
  readonly fontSize?: 'small' | 'inherit' | 'medium' | 'large'
}

export const HostStatusIcon: FC<HostStatusIconProps> = ({ status, fontSize = 'small' }) => {
  const theme = useTheme()

  if (!status) {
    return <ComputerOutlined fontSize={fontSize} aria-hidden="true" />
  }

  const color = getHostStatusColor(status, theme)
  const label = HOST_STATUS_LABELS[status]

  return (
    <Tooltip {...standardTooltipProps} title={label}>
      <ComputerOutlined fontSize={fontSize} sx={{ color }} />
    </Tooltip>
  )
}
